<template>
  <form>
    <b-row>
      <b-col>
        <b-row>
          <b-col cols="10" class="pr-0">
            <b-form-group>
              <label class="form-control-label">
                {{ $t('views.user.form.oldPassword') }}:
              </label>
              <input
                v-model="item.oldPassword"
                :class="['form-control', isInvalid('oldPassword') ? 'is-invalid' : '']"
                type="password"
              >
              <div
                v-if="isInvalid('oldPassword')" class="invalid-feedback">
                {{ violations.oldPassword }}
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="10" class="pr-0">
            <b-form-group>
              <label class="form-control-label">
                {{ $t('views.user.form.password') }}:
              </label>
              <input
                v-if="visiblePassword === 0"
                v-model="item.newPassword"
                :class="['form-control', isInvalid('newPassword') ? 'is-invalid' : '']"
                type="password"
              >
              <input
                v-else
                v-model="item.newPassword"
                :class="['form-control', isInvalid('newPassword') ? 'is-invalid' : '']"
                type="text"
              >
              <div
                v-if="isInvalid('newPassword')" class="invalid-feedback">
                {{ violations.newPassword }}
              </div>
            </b-form-group>
          </b-col>
          <b-col align-self="center" class="pl-0" cols="2">
            <b-form-checkbox class="ml-2 mt-3" @change="changeVisibleState()">{{ passwordText }}</b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="10" class="pr-0">
            <b-form-group>
              <label class="form-control-label">
                {{ $t('views.user.form.confirmPassword') }}:
              </label>
              <input
                v-if="visiblePassword === 0"
                v-model="item.newPasswordConfirmation"
                :class="['form-control', isInvalid('newPassword') ? 'is-invalid' : '']"
                type="password"
              >
              <input
                v-else
                v-model="item.newPasswordConfirmation"
                :class="['form-control', isInvalid('newPassword') ? 'is-invalid' : '']"
                type="text"
              >
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <button @click="$emit('submit')" type="button" class="btn btn-primary">{{ $t('buttons.submit') }}</button>
      </b-col>
    </b-row>
  </form>
</template>

<script>
export default {
  name: 'ChangePasswordForm',
  props: {
    values: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: () => {}
    },
    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      visiblePassword: 0,
      passwordText: this.$t('buttons.showPassword')
    }
  },
  computed: {
    item () {
      return this.initialValues || this.values
    },
    violations () {
      return this.errors || {}
    }
  },
  methods: {
    changeVisibleState () {
      if (this.visiblePassword === 0) {
        this.visiblePassword = 1
        this.passwordText = this.$t('buttons.hidePassword')
      } else {
        this.visiblePassword = 0
        this.passwordText = this.$t('buttons.showPassword')
      }
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>

<style scoped>

</style>
